import Particles from "react-tsparticles";
import ParticleConfig from "./particle-config";



export default function Background(){
    return(<Particles params={ParticleConfig}/>)
}